module.exports = __webpack_public_path__ + "img/nets.eb7e238e.png";